"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluralizedTranslationToJSON = exports.PluralizedTranslationFromJSONTyped = exports.PluralizedTranslationFromJSON = exports.instanceOfPluralizedTranslation = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PluralizedTranslation interface.
 */
function instanceOfPluralizedTranslation(value) {
    var isInstance = true;
    isInstance = isInstance && "other" in value;
    return isInstance;
}
exports.instanceOfPluralizedTranslation = instanceOfPluralizedTranslation;
function PluralizedTranslationFromJSON(json) {
    return PluralizedTranslationFromJSONTyped(json, false);
}
exports.PluralizedTranslationFromJSON = PluralizedTranslationFromJSON;
function PluralizedTranslationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'other': json['other'],
        'zero': !(0, runtime_1.exists)(json, 'zero') ? undefined : json['zero'],
        'one': !(0, runtime_1.exists)(json, 'one') ? undefined : json['one'],
        'two': !(0, runtime_1.exists)(json, 'two') ? undefined : json['two'],
        'few': !(0, runtime_1.exists)(json, 'few') ? undefined : json['few'],
        'many': !(0, runtime_1.exists)(json, 'many') ? undefined : json['many'],
    };
}
exports.PluralizedTranslationFromJSONTyped = PluralizedTranslationFromJSONTyped;
function PluralizedTranslationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'other': value.other,
        'zero': value.zero,
        'one': value.one,
        'two': value.two,
        'few': value.few,
        'many': value.many,
    };
}
exports.PluralizedTranslationToJSON = PluralizedTranslationToJSON;
